module.exports = __webpack_public_path__ + "static/loosechange-3-4545670a8f95427191011c7329a56f95.png";